import { CSSProperties, ReactNode } from 'react';

import { ValueOf } from '~types/common';

import CardTitle from '../CardTitle';
import { COMPANY_DETAIL_MENU } from './constants';
import * as S from './style';

export interface CardProps {
  title?: string;
  rightCardHeader?: ReactNode;
  children?: ReactNode;
  sectionId: ValueOf<typeof COMPANY_DETAIL_MENU>;
  registerRef?: (element: HTMLElement, id: ValueOf<typeof COMPANY_DETAIL_MENU>) => void;
  style?: CSSProperties;
  isNew?: boolean;
}

function Card({
  title,
  rightCardHeader,
  children,
  sectionId,
  registerRef,
  isNew,
  style,
}: CardProps) {
  return (
    <S.Wrapper
      ref={(element) => element && registerRef && registerRef(element, sectionId)}
      id={sectionId}>
      <S.CardHeader>
        <CardTitle>
          {title}
          {isNew && <S.BadgeNew>new</S.BadgeNew>}
        </CardTitle>
        {rightCardHeader}
      </S.CardHeader>
      <S.CardConent style={style}>{children}</S.CardConent>
    </S.Wrapper>
  );
}

export default Card;
